import CompassComponent from 'components/marketingSite/salaryCompass/CompassComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type SalaryCompassPageProps = WithBaseUrl;

const SalaryCompassPage: React.FC<SalaryCompassPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('salary-compass');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('salary-compass.page_title')}
        url={APP_URLS.salaryCompass}
        desc={t('salary-compass.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_salary_compass.png'
        )}`}
        indexable={true}
      />
      <CompassComponent />
    </>
  );
};

export default SalaryCompassPage;

export const getStaticProps: GetStaticProps<SalaryCompassPageProps> = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'salary-compass'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
